import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Helmet from "react-helmet";
import MobileNotAvailableModal from "./mobile-not-available-modal";

const APP_ID = "1444818920";

class UniversalLink extends Component {
  state = { showFallback: false };

  getAppUrl = () => {
    const { match, location, type } = this.props;
    const query = new URLSearchParams(location.search);

    // info-card uses ?track=, album/playlist use ?id=, movie-night uses path params
    const id =
      match.params.id ||
      match.params.slug ||
      (type === "info-card" ? query.get("track") : query.get("id")) ||
      "";

    return `nyarchives://${type}${id ? "/" + id : ""}`;
  };

  handleOpenInApp = () => {
    const scheme = this.getAppUrl();
    window.location.href = scheme;

    // If the app opens, the page becomes hidden. If not, show download modal.
    setTimeout(() => {
      if (!document.hidden) {
        this.setState({ showFallback: true });
      }
    }, 2500);
  };

  render() {
    const { label } = this.props;
    const { showFallback } = this.state;
    const appUrl = this.getAppUrl();
    return (
      <div className="universal-link-page responsive-page">
        <Helmet>
          <meta
            name="apple-itunes-app"
            content={`app-id=${APP_ID}, app-argument=${appUrl}`}
          />
        </Helmet>
        <div className="content-container">
          <div className="header-image" />
          <button className="action-button" onClick={this.handleOpenInApp}>
            {label}
          </button>
        </div>
        <MobileNotAvailableModal
          visible={showFallback}
          onClose={() => this.setState({ showFallback: false })}
        />
      </div>
    );
  }
}

export default withRouter(UniversalLink);
